import { useState } from "react";
import { doc, setDoc, getDoc } from "firebase/firestore";
import { db } from "./firebase";

const UPI_ID = "9366239614@ptaxis"; // Replace with your friend's real UPI ID
const PRICE = 99;

export default function Premium({ user, onBack }) {
  const [showPayment, setShowPayment] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [txnId, setTxnId] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const upiLink = `upi://pay?pa=${UPI_ID}&pn=MyMusic&am=${PRICE}&cu=INR&tn=MyMusic Premium`;
  const qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(upiLink)}`;

  async function handleSubmitPayment() {
    if (!txnId.trim()) { alert("Please enter your UPI transaction reference ID."); return; }
    setSubmitting(true);
    try {
      await setDoc(doc(db, "premiumRequests", user.uid), {
        uid: user.uid,
        email: user.email,
        displayName: user.displayName || "",
        txnId: txnId.trim(),
        amount: PRICE,
        status: "pending",
        requestedAt: new Date().toISOString(),
      });
      setSubmitted(true);
    } catch {
      alert("Failed to submit. Please try again or contact support@mymusicstream.online");
    }
    setSubmitting(false);
  }

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 200, background: "#000", color: "#fff", fontFamily: "'DM Sans',sans-serif", overflowY: "auto" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Syne:wght@700;800&family=DM+Sans:wght@400;500;600&display=swap'); @keyframes glow { 0%,100%{box-shadow:0 0 20px rgba(29,185,84,0.3)} 50%{box-shadow:0 0 40px rgba(29,185,84,0.6)} }`}</style>

      {/* Header */}
      <div style={{ background: "linear-gradient(135deg, #0d2818 0%, #000 60%)", padding: "20px 16px 32px", textAlign: "center", position: "relative" }}>
        <button onClick={onBack} style={{ position: "absolute", left: 16, top: 20, background: "#111", border: "1px solid #222", color: "#fff", width: 34, height: 34, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <svg viewBox="0 0 24 24" style={{ width: 14, height: 14, fill: "none", stroke: "#fff", strokeWidth: 2 }}><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <div style={{ fontSize: 40, marginBottom: 12 }}>⭐</div>
        <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 28, fontWeight: 800, marginBottom: 8, letterSpacing: "-0.5px" }}>MyMusic Premium</div>
        <div style={{ fontSize: 14, color: "#666", maxWidth: 280, margin: "0 auto" }}>Support MyMusic and unlock the full experience</div>
      </div>

      <div style={{ padding: "0 16px 40px" }}>
        {/* Plan card */}
        <div style={{ background: "linear-gradient(135deg, #0d2818, #111)", borderRadius: 20, padding: 20, border: "1.5px solid #1db954", marginBottom: 20, position: "relative", animation: "glow 2s infinite" }}>
          <div style={{ position: "absolute", top: -10, right: 16, background: "#1db954", color: "#000", fontSize: 11, fontWeight: 700, padding: "3px 10px", borderRadius: 50 }}>
            Most Popular
          </div>
          <div style={{ display: "flex", alignItems: "baseline", gap: 6, marginBottom: 4 }}>
            <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 36, fontWeight: 800, color: "#1db954" }}>₹{PRICE}</div>
            <div style={{ fontSize: 13, color: "#555" }}>per month</div>
          </div>
          <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Premium</div>

          {[
            "Ad-free listening experience",
            "Unlimited song uploads",
            "Premium badge on your profile",
            "Priority support",
          ].map((f, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
              <div style={{ width: 20, height: 20, borderRadius: "50%", background: "#1db95422", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <svg viewBox="0 0 24 24" style={{ width: 12, height: 12, fill: "none", stroke: "#1db954", strokeWidth: 2.5 }}><polyline points="20 6 9 17 4 12"/></svg>
              </div>
              <span style={{ fontSize: 13, color: "#ccc" }}>{f}</span>
            </div>
          ))}
        </div>

        {!showPayment ? (
          <button onClick={() => setShowPayment(true)}
            style={{ width: "100%", padding: 16, borderRadius: 50, border: "none", background: "#1db954", color: "#000", fontSize: 16, fontWeight: 700, cursor: "pointer", marginBottom: 10 }}>
            🚀 Get Premium — ₹{PRICE}/mo
          </button>
        ) : !showQR && !submitted ? (
          <div style={{ background: "#0a0a0a", borderRadius: 16, padding: 20, border: "1px solid #1a1a1a" }}>
            <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 16, fontWeight: 800, marginBottom: 16, textAlign: "center" }}>Choose Payment Method</div>
            {[
              { name: "Paytm", icon: "💳", scheme: `paytmmp://pay?pa=${UPI_ID}&pn=MyMusic&am=${PRICE}&cu=INR&tn=MyMusicPremium` },
              { name: "Google Pay", icon: "🟢", scheme: `tez://upi/pay?pa=${UPI_ID}&pn=MyMusic&am=${PRICE}&cu=INR&tn=MyMusicPremium` },
              { name: "PhonePe", icon: "🟣", scheme: `phonepe://pay?pa=${UPI_ID}&pn=MyMusic&am=${PRICE}&cu=INR&tn=MyMusicPremium` },
              { name: "Any UPI App", icon: "📱", scheme: upiLink },
            ].map(method => (
              <div key={method.name} onClick={() => {
                window.location.href = method.scheme;
                setTimeout(() => setShowQR(true), 1500);
              }} style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", borderRadius: 12, background: "#111", border: "1px solid #1a1a1a", marginBottom: 10, cursor: "pointer" }}>
                <span style={{ fontSize: 22 }}>{method.icon}</span>
                <span style={{ fontSize: 14, fontWeight: 600, color: "#fff", flex: 1 }}>{method.name}</span>
                <svg viewBox="0 0 24 24" style={{ width: 16, height: 16, fill: "none", stroke: "#555", strokeWidth: 2 }}><polyline points="9 18 15 12 9 6"/></svg>
              </div>
            ))}
            <button onClick={() => setShowQR(true)} style={{ width: "100%", padding: 12, borderRadius: 50, border: "1px solid #2a2a2a", background: "transparent", color: "#888", fontSize: 13, cursor: "pointer", marginTop: 8 }}>
              Or scan QR code instead
            </button>
          </div>
        ) : !submitted ? (
          <div style={{ background: "#0a0a0a", borderRadius: 16, padding: 20, border: "1px solid #1a1a1a" }}>
            <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 16, fontWeight: 800, marginBottom: 4, textAlign: "center" }}>Pay via UPI</div>
            <div style={{ fontSize: 12, color: "#555", textAlign: "center", marginBottom: 16 }}>Scan the QR code or pay manually, then submit your reference below</div>

           <div style={{ display: "flex", justifyContent: "center", marginBottom: 16 }}>
              <img src={qrCodeUrl} alt="UPI QR Code" style={{ width: 180, height: 180, borderRadius: 12, border: "1px solid #2a2a2a" }} />
            </div>

            <a href={upiLink} style={{ display: "block", textDecoration: "none", marginBottom: 16 }}>
              <div style={{ width: "100%", padding: "14px", borderRadius: 50, background: "#1db954", color: "#000", fontSize: 14, fontWeight: 700, textAlign: "center", cursor: "pointer" }}>
                📱 Pay with UPI App
              </div>
            </a>

            <div style={{ fontSize: 11, color: "#444", textAlign: "center", marginBottom: 16 }}>or scan the QR code above with any UPI app</div>

            <div style={{ background: "#111", borderRadius: 10, padding: "10px 14px", marginBottom: 16, textAlign: "center" }}>
              <div style={{ fontSize: 11, color: "#555", marginBottom: 2 }}>UPI ID</div>
              <div style={{ fontSize: 14, fontWeight: 700, color: "#1db954", fontFamily: "monospace" }}>{UPI_ID}</div>
            </div>

            <div style={{ fontSize: 11, color: "#555", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>UPI Transaction Reference ID</div>
            <input
              value={txnId}
              onChange={e => setTxnId(e.target.value)}
              placeholder="e.g. 123456789012"
              style={{ width: "100%", padding: "12px 14px", borderRadius: 10, border: "1px solid #2a2a2a", background: "#000", color: "#fff", fontSize: 14, outline: "none", marginBottom: 14, boxSizing: "border-box" }}
            />

           <div style={{ background: "rgba(245,158,11,0.1)", border: "1px solid rgba(245,158,11,0.3)", borderRadius: 10, padding: "10px 14px", marginBottom: 14 }}>
              <div style={{ fontSize: 12, color: "#f59e0b", fontWeight: 700, marginBottom: 4 }}>⚠️ Important</div>
              <div style={{ fontSize: 12, color: "#ccc", lineHeight: 1.5 }}>After completing your payment, please submit the transaction ID below so we can verify and activate your Premium. If you forget to submit it, contact support@mymusicstream.online with your payment proof.</div>
            </div>

            <button onClick={handleSubmitPayment} disabled={submitting}
              style={{ width: "100%", padding: 14, borderRadius: 50, border: "none", background: submitting ? "#333" : "#1db954", color: submitting ? "#777" : "#000", fontSize: 14, fontWeight: 700, cursor: submitting ? "not-allowed" : "pointer" }}>
              {submitting ? "Submitting..." : "Submit for Verification"}
            </button>
            <p style={{ fontSize: 11, color: "#444", textAlign: "center", marginTop: 12 }}>Your Premium will be activated within 24 hours after verification.</p>
          </div>
        ) : (
          <div style={{ background: "#0a0a0a", borderRadius: 16, padding: 24, textAlign: "center", border: "1px solid #1db954" }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
            <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 18, fontWeight: 800, marginBottom: 8 }}>Payment Submitted!</div>
            <p style={{ fontSize: 13, color: "#888", lineHeight: 1.6 }}>We're verifying your payment. Your Premium will activate within 24 hours. You'll receive a notification once it's confirmed.</p>
          </div>
        )}

        {/* Why upgrade */}
        <div style={{ marginTop: 24, background: "#0a0a0a", borderRadius: 16, padding: 16, border: "1px solid #1a1a1a" }}>
          <div style={{ fontFamily: "'Syne',sans-serif", fontSize: 14, fontWeight: 800, marginBottom: 12, textAlign: "center" }}>Why upgrade?</div>
          {[
            { icon: "🚫", text: "Remove all ads — pure music experience" },
            { icon: "🎤", text: "Upload unlimited songs as an artist" },
            { icon: "⭐", text: "Stand out with a Premium badge" },
            { icon: "💬", text: "Get priority support from our team" },
          ].map((item, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 0", borderBottom: i < 3 ? "1px solid #111" : "none" }}>
              <span style={{ fontSize: 18 }}>{item.icon}</span>
              <span style={{ fontSize: 13, color: "#888" }}>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}